import {charcoal} from '../sass/base/_exports.sass';

export const RevisionIcon = (props) => {
  const {color = charcoal, className = '', ratio = 1} = props;

  const width = 32;
  const height = 32;

  const style = {height: `${ratio * height}px`, width: `${ratio * width}px`};

  return (
    <svg
      viewBox="0 0 25 25"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <path
        d="M20.39 10.23C20.1739 9.72067 19.9097 9.23313 19.601 8.774L17.943 9.893C18.4208 10.6033 18.756 11.3998 18.93 12.238C19.1072 13.1118 19.1072 14.0122 18.93 14.886C18.8431 15.3081 18.7145 15.7204 18.546 16.117C18.3822 16.5067 18.1802 16.8791 17.943 17.229C17.469 17.928 16.8663 18.5304 16.167 19.004C15.4572 19.4816 14.6615 19.8168 13.824 19.991C12.9506 20.166 12.0513 20.166 11.178 19.991C9.92103 19.7328 8.76763 19.111 7.86097 18.203C7.26207 17.6037 6.78404 16.8949 6.45297 16.115C6.28592 15.7184 6.15798 15.3065 6.07097 14.885C5.80699 13.5836 5.94007 12.2329 6.45297 11.008C6.78277 10.2283 7.26059 9.51989 7.85997 8.922C8.45909 8.32411 9.16718 7.8465 9.94597 7.515C10.341 7.348 10.756 7.219 11.176 7.133C11.283 7.111 11.392 7.101 11.5 7.084V10.125L16.5 6.125L11.5 2.125V5.063C11.2569 5.08991 11.015 5.12695 10.775 5.174C9.67912 5.39856 8.63829 5.83691 7.71197 6.464C6.06646 7.57402 4.8575 9.22105 4.29171 11.1236C3.72592 13.0262 3.83842 15.0662 4.60997 16.895C5.03951 17.9132 5.66272 18.8384 6.44497 19.619C7.22616 20.3987 8.14992 21.021 9.16597 21.452C10.7633 22.1278 12.5284 22.3018 14.227 21.951C15.5866 21.67 16.8577 21.0631 17.9311 20.1824C19.0044 19.3017 19.8478 18.1736 20.389 16.895C20.609 16.375 20.778 15.834 20.889 15.287C21.1208 14.1487 21.1208 12.9753 20.889 11.837C20.775 11.2864 20.6079 10.7483 20.39 10.23Z"
        fill={color}
      />
    </svg>
  );
};
